import React from 'react';
import { Flex } from '../Flex';
import { Typography } from '../Typography';
export type ArticleAdviceResponseValue = Record<'text' | 'dateLabel' | 'userLabel', string>;
type Props = {
  value: ArticleAdviceResponseValue;
};
export const ArticleAdviceResponse = ({
  value: {
    text,
    dateLabel,
    userLabel
  }
}: Props) => <>
    <Typography style={{
    wordWrap: 'break-word'
  }} data-sentry-element="Typography" data-sentry-source-file="index.tsx">
      {text}
    </Typography>

    <Flex justifyContent="space-between" data-sentry-element="Flex" data-sentry-source-file="index.tsx">
      <Typography fontSize="12px" data-sentry-element="Typography" data-sentry-source-file="index.tsx">
        {dateLabel}
      </Typography>
      <Typography fontSize="12px" data-sentry-element="Typography" data-sentry-source-file="index.tsx">
        {userLabel}
      </Typography>
    </Flex>
  </>;
export type ArticleAdviceResponseProps = Props;